"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("../01_atoms/Button"));

var _ElementGroup = _interopRequireDefault(require("../01_atoms/ElementGroup"));

var _SquaredText = _interopRequireDefault(require("../01_atoms/SquaredText"));

var _KeyValueElement = _interopRequireDefault(require("../01_atoms/KeyValueElement"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TripSeatDetails = function TripSeatDetails(_ref) {
  var numberOfPassengers = _ref.numberOfPassengers,
      _ref$selectedSeats = _ref.selectedSeats,
      selectedSeats = _ref$selectedSeats === void 0 ? [] : _ref$selectedSeats,
      _ref$onEditLink = _ref.onEditLink,
      onEditLink = _ref$onEditLink === void 0 ? null : _ref$onEditLink,
      _ref$onEdit = _ref.onEdit,
      onEdit = _ref$onEdit === void 0 ? null : _ref$onEdit,
      t = _ref.translator,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      id = _ref.id,
      _ref$dontHighlight = _ref.dontHighlight,
      dontHighlight = _ref$dontHighlight === void 0 ? false : _ref$dontHighlight;
  var nSelectedSeats = selectedSeats.length;
  var seatsLeftToBook = numberOfPassengers - nSelectedSeats;
  return /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], {
    id: id,
    style: style,
    title: t('Placement')
  }, /*#__PURE__*/_react["default"].createElement(_KeyValueElement["default"], {
    title: nSelectedSeats === 0 ? t('No seats selected yet') : t('Selected seats'),
    subtitle: t('This bus uses reserved seats'),
    value: selectedSeats.map(function (s) {
      return /*#__PURE__*/_react["default"].createElement(_SquaredText["default"], {
        key: "placement:".concat(s),
        style: {
          width: 24,
          height: 24
        }
      }, s);
    })
  }, (onEditLink || onEdit) && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    to: onEditLink,
    onClick: onEdit,
    fluid: true,
    primary: !dontHighlight && seatsLeftToBook > 0
  }, seatsLeftToBook > 0 ? t('Select seats') : t('Change seats'))));
};

var _default = TripSeatDetails;
exports["default"] = _default;